import React, { Fragment, PureComponent } from 'react';
import { Link, withRouter } from 'react-router-dom';
import styled from 'styled-components';
import { Row, Col } from 'react-flexbox-grid';
import { connect } from 'react-redux';
import ShoppingIcon from './icons/shopping';
import ReceiptIcon from './icons/receipt';
import UserIcon from './icons/user';
import CallToAction from '../SummaryComponents/CallToAction';

export const Wrapper = styled.nav`
  display: flex;
  flex-direction: column;
  background-color: #fff;
  position: fixed;
  bottom: 0;
  width: 100%;
  height: 60px;
  box-shadow: 0 -1px 4px 0 rgba(0,0,0,0.15);
  z-index: 10;
`;

export const NavLink = styled(Link)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  font-size: 12px;
  width: 100%;
`;

export const NavRow = styled(Row)`
  width: 100%;
  padding: 0;
  margin: 0;
`;

export const OfflineState = styled.div`
  width: 100%;
  height: 20px;
  display: ${props => (props.online ? 'none' : 'flex')};
  justify-content: center;
  align-items: center;
  color: #fff;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0;
`;

export const Column = styled(Col)`
  width: 100%;
  padding: 0;

  :nth-child(3){
    display: flex;
    justify-content: center;
  }
`;

export const IconWrapper = styled.div`
  width: 48px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 10px;
  margin-bottom: 5px;

  ${props => props.active && `
    color: #FFBF00;
  `}
`;

class Navigation extends PureComponent {
  render() {
    const { items, history, location: { pathname }, canCheckout } = this.props;

    const paths = ['/login', '/checkout', '/verification', '/order-failed', '/location']
    const dynamicPaths = ['/order-status'];
    const noDynamicPaths = !dynamicPaths.find(path => pathname.includes(path));
    const showCheckout = items.length > 0 && paths.indexOf(pathname) < 0 && noDynamicPaths;

    if (canCheckout && pathname === '/checkout') {
      return null;
    }

    // The checkout button sits on top of the tab bar rather than replacing it,
    // so Orders and Account stay reachable while a basket is in progress.
    return (
      <Fragment>
        {showCheckout && <CallToAction text='Checkout now' type='button' offset={60} onClick={() => history.push('/checkout')} />}
        <Wrapper className='is-hidden-desktop'>
          <NavRow around='xs'>
            <Column xs={2}>
              <NavLink to='/shops' active={false} className='has-text-grey'>
                <IconWrapper>
                  <ShoppingIcon />
                </IconWrapper>
                Shops
              </NavLink>
            </Column>
            <Column xs={2}>
              <NavLink to='/orders' active={false} className='has-text-grey'>
                <IconWrapper>
                  <ReceiptIcon />
                </IconWrapper>
                Orders
              </NavLink>
            </Column>
            <Column xs={2}>
              <NavLink to='/edit-account' active={false} className='has-text-grey'>
                <IconWrapper>
                  <UserIcon />
                </IconWrapper>
                Account
              </NavLink>
            </Column>
          </NavRow>
        </Wrapper>
      </Fragment>
    );
  }
}

const mapStateToProps = state => ({
  items: state.basket.menuItems,
  canCheckout: state.basket.canCheckout,
});

export default connect(mapStateToProps)(withRouter(Navigation));